const iconData = {
  account: {
    icon: "/images/needs/icon-account1.svg",
  },
  home: {
    icon: "/images/needs/icon-home3.svg",
  },
  savings: {
    icon: "/images/needs/icon-savings1.svg",
  },
  credit: {
    icon: "/images/needs/icon-additional-funds1.svg",
  },
  travel: {
    icon: "/images/needs/icon-excursion1.svg",
  },
  furniture: {
    icon: "/images/needs/icon-furniture1.svg",
  },
  card: {
    icon: "/images/needs/icon-bank-card1.svg",
  },
  insurance: {
    icon: "/images/needs/icon-digital.svg",
  },
};

export default iconData;
